import Button from '@/common/components/Button'
import Modal from '@/common/components/Modal'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useDeleteFeeTemplate } from '@/features/feeTemplates/hooks/useDeleteFeeTemplate'
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

interface ModalDeleteFeeTemplateProps {
  feeTemplateId?: string
  onError: (error: ErrorResponse) => void
  operationKlassToCheckPermission?: string
}

export const ModalDeleteFeeTemplate = ({ feeTemplateId, onError, operationKlassToCheckPermission }: ModalDeleteFeeTemplateProps) => {
  const queryClient = useQueryClient()
  const navigate = useNavigate()

  const [isOpen, setIsOpen] = useState(false)

  const onSuccess = () => {
    setIsOpen(false)
    queryClient.invalidateQueries({ queryKey: ['feeTemplate', feeTemplateId] })
    queryClient.invalidateQueries({ queryKey: ['feeTemplates'] })
    navigate('/fee-templates')
  }

  const { mutate: deleteFeeTemplate, isPending: deleteFeeTemplateIsPending } = useDeleteFeeTemplate({
    onSuccess,
    onError: (error) => {
      setIsOpen(false)
      onError(error)
    },
  })

  return (
    <Modal
      Trigger={
        <Button operationKlassToCheckPermission={operationKlassToCheckPermission} type="button" variant="error" className="shadow-[4px_4px_8px_4px_rgba(0,_0,_0,_0.2)]">
          Deletar
        </Button>
      }
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title="Você tem certeza?"
      showClose={false}
      useCancellableFooter
      confirmButtonText="Deletar tarifa"
      disabled={deleteFeeTemplateIsPending}
      onConfirm={() => deleteFeeTemplate(feeTemplateId)}
    />
  )
}
